module.exports = __webpack_public_path__ + "img/nema.78aa6ce6.jpg";